module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Вы подключили сервис видеособеседований!","text":"Чтобы начать получать видеоотклики, вам необходимо настроить сценарии собеседований для импортированных вакансий. Нажмите на ссылку <b>“настроить сценарий собеседования”</b> рядом с вакансией и пройдите мастер подбора вопросов."}}')
  delete Component.options._Ctor
}
